import React, { useState } from "react";
import { ReactComponent as EyeOpen } from "../../assets/icons/eye.svg";
import { ReactComponent as EyeClosed } from "../../assets/icons/eye-slash.svg";
import { Link } from "react-router-dom";

const backgroundContainer: React.CSSProperties = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "#124280",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 0,
};

const containerStyle: React.CSSProperties = {
  width: 521,
  height: "auto",
  background: "#fff",
  borderRadius: 12,
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  padding: "50px 34px",
  boxSizing: "border-box",
  zIndex: 1,
};

const inputContainerStyle: React.CSSProperties = {
  width: "100%",
  maxWidth: 454,
  height: 54,
  border: "1px solid #000",
  borderRadius: 8,
  display: "flex",
  alignItems: "center",
  paddingLeft: 18,
  marginBottom: 18,
  boxSizing: "border-box",
  background: "#fff",
  position: "relative",
};

const inputStyle: React.CSSProperties = {
  fontFamily: "Poppins, sans-serif",
  fontWeight: 500,
  fontSize: 16,
  color: "#8A8A8A",
  outline: "none",
  border: "none",
  background: "transparent",
  height: "100%",
  width: "100%",
  paddingRight: 36,
};

const eyeIconStyle: React.CSSProperties = {
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)",
  cursor: "pointer",
  fontSize: 22,
  color: "#8A8A8A",
  background: "none",
  border: "none",
  display: "flex",
  alignItems: "center",
};

const linkStyle: React.CSSProperties = {
  fontFamily: "Poppins, sans-serif",
  fontWeight: 500,
  fontSize: 16,
  color: "#9E201E",
  marginBottom: 20,
  cursor: "pointer",
};

const cadastroStyle: React.CSSProperties = {
  ...linkStyle,
  color: "#124280",
};

const buttonStyle: React.CSSProperties = {
  width: 454,
  height: 50,
  background: "#124280",
  borderRadius: 8,
  color: "#fff",
  fontFamily: "Poppins, sans-serif",
  fontWeight: 500,
  fontSize: 24,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "none",
  cursor: "pointer",
  marginTop: 6,
};

const msgStyle: React.CSSProperties = {
  width: 454,
  marginTop: 10,
  fontFamily: "Poppins, sans-serif",
  fontSize: 14,
};

const CadastroContainer: React.FC = () => {
  const [codigo, setCodigo] = useState(""); // 14178 para suprimentos
  const [nome, setNome] = useState(""); // obrigatório no backend
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg] = useState<{ type: "ok" | "err"; text: string } | null>(
    null
  );

  function onlyDigits(v: string) {
    return v.replace(/\D+/g, "");
  }

  function validate(): string | null {
    if (!codigo.trim()) return "Informe o código de acesso.";
    if (!nome.trim()) return "Informe o seu nome completo.";
    if (!email.trim() || !email.includes("@"))
      return "Informe um e-mail válido.";
    if (senha.length < 8) return "A senha deve ter pelo menos 8 caracteres.";
    return null;
    // Obs.: o backend validará novamente e retornará 403 se o código não for 14178.
  }

  async function handleRegister() {
    setMsg(null);
    const err = validate();
    if (err) {
      setMsg({ type: "err", text: err });
      return;
    }

    setSubmitting(true);
    try {
      const res = await fetch(
        "https://api.eva-googlemarine.com/auth/register",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            nome: nome.trim(),
            email: email.trim().toLowerCase(),
            senha,
            codigo: Number(codigo),
          }),
        }
      );

      const data = await res.json().catch(() => ({}));
      if (!res.ok || data?.ok === false) {
        const reason =
          data?.erro ||
          data?.message ||
          `Falha ao cadastrar (HTTP ${res.status}).`;
        throw new Error(reason);
      }

      setMsg({
        type: "ok",
        text: "Cadastro realizado com sucesso! Você já pode fazer login.",
      });
      // Se quiser redirecionar para a tela de login:
      // navigate("/login");
    } catch (e: any) {
      setMsg({ type: "err", text: e?.message || "Erro ao cadastrar." });
    } finally {
      setSubmitting(false);
    }
  }

  function onEnterSubmit(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === "Enter") {
      e.preventDefault();
      handleRegister();
    }
  }

  return (
    <div style={backgroundContainer}>
      <div style={containerStyle}>
        <div
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: 500,
            fontSize: 50,
            color: "#000",
            marginBottom: 5,
            textAlign: "left",
            width: "100%",
          }}
        >
          Cadastrar-se
        </div>
        <div
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: 500,
            fontSize: 14,
            color: "#000",
            marginBottom: 20,
            textAlign: "left",
            width: "100%",
          }}
        >
          Continue o seu acesso para a Googlemarine
        </div>

        {/* Código de acesso*/}
        {/* Código de acesso (mascarado) */}
        <div style={inputContainerStyle}>
          <input
            style={inputStyle}
            type="password"
            inputMode="numeric"
            autoComplete="one-time-code" // opcional; ajuda em mobile
            value={codigo}
            onChange={(e) => {
              const v = onlyDigits(e.target.value).slice(0, 10); // opcional: limita tamanho
              setCodigo(v);
            }}
            onKeyDown={onEnterSubmit}
            placeholder="Código de Acesso"
          />
        </div>

        {/* Nome */}
        <div style={inputContainerStyle}>
          <input
            style={inputStyle}
            type="text"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            onKeyDown={onEnterSubmit}
            placeholder="Nome completo"
          />
        </div>

        {/* E-mail */}
        <div style={inputContainerStyle}>
          <input
            style={inputStyle}
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={onEnterSubmit}
            placeholder="E-mail"
          />
        </div>

        {/* Senha */}
        <div style={{ ...inputContainerStyle, marginBottom: 10 }}>
          <input
            style={inputStyle}
            type={showPassword ? "text" : "password"}
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            onKeyDown={onEnterSubmit}
            placeholder="Senha (mín. 8 caracteres)"
          />
          <span
            style={eyeIconStyle}
            onClick={() => setShowPassword((v) => !v)}
            tabIndex={0}
            aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
            role="button"
            title={showPassword ? "Ocultar senha" : "Mostrar senha"}
          >
            {showPassword ? <EyeClosed /> : <EyeOpen />}
          </span>
        </div>

        {/* Mensagem de feedback */}
        {msg && (
          <div
            style={{
              ...msgStyle,
              color: msg.type === "ok" ? "#0f5132" : "#842029",
            }}
          >
            {msg.text}
          </div>
        )}

        <div style={cadastroStyle}>
          <Link
            to="/entrar"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            Já possui uma conta? Acesse agora
          </Link>
        </div>

        <button
          style={{
            ...buttonStyle,
            opacity: submitting ? 0.75 : 1,
            cursor: submitting ? "not-allowed" : "pointer",
          }}
          onClick={handleRegister}
          disabled={submitting}
        >
          {submitting ? "Enviando..." : "Cadastrar-se"}
        </button>
      </div>
    </div>
  );
};

export default CadastroContainer;
